import React from 'react';
import Carousel from '@nerdwallet/react-carousel';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import DiversityCarouselTile from './diversity-carousel-tile';
import styles from './diversity-carousel.module.less';

const DiversityCarousel = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile) => (
    <DiversityCarouselTile {...tile} />
  ));
  return (
    <React.Fragment>
      <div
        className={classNames([
          classes('display-none--wide'),
          classes('display-block'),
        ])}
      >
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          slidesToShow="1"
          className={styles.carouselContainer}
        >
          {renderedTiles}
        </Carousel>
      </div>
      <div
        className={classNames([
          classes('display-none'),
          classes('display-block--wide'),
        ])}
      >
        {' '}
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          slidesToShow="3"
          className={styles.carouselContainer}
        >
          {renderedTiles}
        </Carousel>
      </div>
    </React.Fragment>
  );
};

DiversityCarousel.propTypes = {
  tiles: PropTypes.object,
};

DiversityCarousel.displayName = 'Diversity Carousel';
DiversityCarousel.analyticsName = 'diversity_carousel';

export default DiversityCarousel;
